import React, { useState } from 'react';
import InitialBar from './InitialBar.js';
import SelectedProdBar from './SelectedProdBar.js';

export default function CompareTable(props) {
	const [showProduct, setShowProduct] = useState(false);
	let compareItems = props.comparableProducts;
	function handleSelectProd() {
		setShowProduct(true);
	}
	function handleCancelSelectProd() {
		setShowProduct(false);
		props.handleCancelComparions();
	}

	if (props.compTableActive || showProduct) {
		return (
			<SelectedProdBar
				comparisonTableId={props.comparisonTableId}
				compareItems={compareItems}
				productPath={props.productPath}
				handleCancelSelectProd={handleCancelSelectProd}
				tabularData={props.tabularData}
				handleComparisonSelection={props.handleComparisonSelection}
			/>
		);
	}
	return <InitialBar handleSelectProd={handleSelectProd} />;
}
